<template>
	<v-sheet class="pa-4" rounded>
		<p class="text-h4">Acceso restringido<p>
		<p>Tu usuario no tiene acceso a esta sección.</p>
		<v-btn @click="irPaginaInicio">
			<v-icon left>
				home
			</v-icon>
			Ir a página principal
		</v-btn>
	</v-sheet>
</template>

<script>
export default {
	methods: {
		irPaginaInicio: function() {
			let vm = this;
			vm.$router.push({name: 'inicio'});
		}
	}
};
</script>
